module.exports = __webpack_public_path__ + "img/profil_lapper_Wiik.f534a608.png";